export const removeSpecialChars = (string: string) => {
    return string.replace(/&|\(|\)|]|\[|-|\^|[+?:*"~|/\\}{}!=><]/g, ' ').replace(/\s+/g, ' ');
};

export const camelCaseToKebabCase = (str: string): string => {
    return str.split('').map((letter, idx) => {
        return letter.toUpperCase() === letter
            ? `${idx !== 0 ? '-' : ''}${letter.toLowerCase()}`
            : letter;
    }).join('');
};

export function slugify (input: string): string {
    if (!input) {
        throw new Error('slugify input is empty');
    }
    const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;';
    const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------';
    const p = new RegExp(a.split('').join('|'), 'g');
    return input.toLowerCase()
        .replace(/\s+/g, '-')
        .replace(p, c => b.charAt(a.indexOf(c)))
        .replace(/&/g, '-and-')
        .replace(/[^\w-]+/g, '')
        .replace(/--+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '');
}

export function generateId (includeSeparator: boolean = true): string {
    function s4 () {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }

    const components = [s4() + s4(), s4(), s4(), s4(), s4() + s4() + s4()];

    if (includeSeparator) {
        return components.join('-');
    } else { return components.join(''); }
}

export function validEmail (email: string) {
    const regex = /^(?!\.)[\w.+-]+(?<!\.)@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
    return regex.test(email);
}

export function validPhone (phone: string) {
    const regex = /^\+[1-9]\d{1,14}$/;
    return regex.test(phone);
}

export function isValidDateString (dateString: string): boolean {
    // Check if string contains common date separators
    if (!/[./-]/.test(dateString)) {
        return false;
    }
    return true;
}

// Function to convert field name to display name.
export function toDisplayName (key: string): string {
    return key
        .replace(/([a-z])([A-Z])/g, '$1 $2') // camelCase to camel Case
        .replace(/^./, (s: string) => s.toUpperCase()); // capitalize first letter
}

export function validHostname (hostname: string): boolean {
    // Must be a proper FQDN with at least one dot (e.g. eu-west-02.quotaguard.com)
    const pattern = /^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
    return pattern.test(hostname);
}

export function isValidIpv4 (value: string): boolean {
    const pattern = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/;
    const m = pattern.exec(value);
    return m !== null && m.slice(1).every(o => Number(o) <= 255);
}

export const getNextNumericSuffix = (existingItems: string[], prefix: string, numericPartSeparator = '_'): string => {
    const values = existingItems.filter(it => it.startsWith(prefix)).map(it => parseInt(it.replace(prefix + numericPartSeparator, '')) || 0);
    if (values.length === 0) { return ''; }
    const lastFieldNumber = Math.max(...values);
    return lastFieldNumber > -1 ? numericPartSeparator + (lastFieldNumber + 1) : '';
};
